<template lang="pug">
.home-stats__item
  .home-stats__title {{title}}
  .home-stats__data-item
    .home-stats__numbers.home-stats__numbers--big(v-if="loading") ---
    .home-stats__numbers.home-stats__numbers--big(v-else) {{urls}}
    .home-stats__data-item-label URLs encurtadas
  .home-stats__data-item
    .home-stats__numbers(v-if="loading") ---
    .home-stats__numbers(v-else) {{clicks}}
    .home-stats__data-item-label visitas/clicks
</template>

<script>
import axios from 'axios';
import { curry } from 'lodash';

const props = {
  period: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  }
};

const data = function () {
  return {
    clicks: null,
    loading: true,
    urls: null
  };
};

const computed = {
};

const endpoint = '';

const mounted = function () {
  this.loadStats();
};

const methods = {
  endpoint () {
    return `/_/stats/${this.period}`;
  },
  loadStats () {
    const $self = this;
    const headers = { 'Accept': 'application/json' };

    axios.get(this.endpoint(), { headers: headers })
      .then(curry(treatSucceededStats)($self));
  }
};

const treatSucceededStats = function (vue, { data: { data: data } }) {
  Object.assign(vue.$data, {
    clicks: data.clicks,
    loading: false,
    urls: data.urls
  });
};

export default {
  name: 'stats-card',
  props,
  data,
  computed,
  mounted,
  methods
}
</script>
